// BROOKSTAR ネーム刺繍: 1〜9枚の小ロット対応費をカート全体で1回だけ管理
(function (global) {
  'use strict';

  if (global.UaSmallLotFee) return;

  var CONFIGURATOR_TAG = 'p2b';
  var FEE_VARIANT_ID = 46441123971268;
  var FEE_PRICE = 2200;
  var MAX_SMALL_LOT_QTY = 9;
  var EVENT_SOURCE = 'ua-small-lot-fee';
  var syncPromise = null;
  var scheduled = null;

  function cartUrl() {
    var base = global.routes && global.routes.cart_url ? global.routes.cart_url : '/cart';
    return base.replace(/\/$/, '') + '.js';
  }

  function routeUrl(key, fallback) {
    var url = global.routes && global.routes[key] ? global.routes[key] : fallback;
    return url.replace(/(\/cart\/(?:add|update|change))(?=\?|$)/, '$1.js');
  }

  function jsonRequest(url, body) {
    return global.fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || json.status) {
          throw new Error(json.description || json.message || 'カートを更新できませんでした。');
        }
        return json;
      });
    });
  }

  function readCart() {
    return global.fetch(cartUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('カートを確認できませんでした。');
      return response.json();
    });
  }

  function properties(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function isFeeItem(item) {
    var props = properties(item);
    return Number(item.variant_id) === FEE_VARIANT_ID ||
      props._ua_small_lot_fee === 'true' ||
      props._ua_item_type === 'small_lot_fee';
  }

  function isConfiguredBody(item) {
    var props = properties(item);
    if (props._ua_configurator !== CONFIGURATOR_TAG) return false;
    if (props._ua_item_type === 'body') return true;
    if (props._ua_item_type) return false;
    return !props._ua_price_band && !props._ua_surcharge_code && !props._ua_small_lot_fee;
  }

  function analyze(cart) {
    var bodyQuantity = 0;
    var feeItems = [];
    (cart.items || []).forEach(function (item) {
      if (isConfiguredBody(item)) bodyQuantity += Number(item.quantity) || 0;
      if (isFeeItem(item)) feeItems.push(item);
    });
    return { bodyQuantity: bodyQuantity, feeItems: feeItems };
  }

  function updateFeeLines(feeItems, keepOne) {
    if (!feeItems.length) return Promise.resolve(false);
    var updates = {};
    var changed = false;
    feeItems.forEach(function (item, index) {
      var target = keepOne && index === 0 ? 1 : 0;
      if (Number(item.quantity) !== target) changed = true;
      updates[item.key] = target;
    });
    if (!changed) return Promise.resolve(false);
    return jsonRequest(routeUrl('cart_update_url', '/cart/update.js'), { updates: updates })
      .then(function () { return true; });
  }

  function feeProperties() {
    return {
      '加工種別': '小ロット対応費',
      '対象': 'ネーム刺繍1〜9枚',
      '料金': '¥2,200／注文',
      _ua_pair_id: 'ua-small-lot-order',
      _ua_small_lot_fee: 'true',
      _ua_item_type: 'small_lot_fee',
      _ua_configurator: CONFIGURATOR_TAG
    };
  }

  function addFeeLine() {
    return jsonRequest(routeUrl('cart_add_url', '/cart/add.js'), {
      items: [{
        id: FEE_VARIANT_ID,
        quantity: 1,
        properties: feeProperties()
      }]
    }).then(function () { return true; });
  }

  function publishRefresh() {
    if (typeof global.publish !== 'function' || typeof global.PUB_SUB_EVENTS === 'undefined') return;
    global.publish(global.PUB_SUB_EVENTS.cartUpdate, {
      source: EVENT_SOURCE,
      cartData: null,
      variantId: FEE_VARIANT_ID
    });
  }

  function reconcile() {
    if (syncPromise) return syncPromise;
    syncPromise = readCart()
      .then(function (cart) {
        var state = analyze(cart);
        var needsFee = state.bodyQuantity >= 1 && state.bodyQuantity <= MAX_SMALL_LOT_QTY;
        if (needsFee && !state.feeItems.length) return addFeeLine();
        return updateFeeLines(state.feeItems, needsFee);
      })
      .then(function (changed) {
        if (changed) publishRefresh();
        return { changed: !!changed };
      })
      .finally(function () {
        syncPromise = null;
      });
    return syncPromise;
  }

  function prepareForAdd(addQuantity) {
    var qty = Number(addQuantity);
    if (!Number.isInteger(qty) || qty < 1) {
      return Promise.reject(new Error('追加枚数が不正です。'));
    }
    var waitForSync = syncPromise || Promise.resolve();
    return waitForSync.then(readCart).then(function (cart) {
      var state = analyze(cart);
      var totalAfterAdd = state.bodyQuantity + qty;
      var needsFee = totalAfterAdd >= 1 && totalAfterAdd <= MAX_SMALL_LOT_QTY;
      if (!needsFee) {
        return updateFeeLines(state.feeItems, false).then(function () {
          return { includeFee: false, totalAfterAdd: totalAfterAdd };
        });
      }
      if (state.feeItems.length) {
        return updateFeeLines(state.feeItems, true).then(function () {
          return { includeFee: false, totalAfterAdd: totalAfterAdd };
        });
      }
      return { includeFee: true, totalAfterAdd: totalAfterAdd };
    });
  }

  function scheduleReconcile() {
    if (scheduled) global.clearTimeout(scheduled);
    scheduled = global.setTimeout(function () {
      scheduled = null;
      reconcile().catch(function (error) {
        console.error('[ua-small-lot-fee] reconcile failed', error);
      });
    }, 80);
  }

  global.UaSmallLotFee = Object.freeze({
    variantId: FEE_VARIANT_ID,
    price: FEE_PRICE,
    maxQuantity: MAX_SMALL_LOT_QTY,
    prepareForAdd: prepareForAdd,
    reconcile: reconcile
  });

  function bind() {
    if (typeof global.subscribe === 'function' && typeof global.PUB_SUB_EVENTS !== 'undefined') {
      global.subscribe(global.PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === EVENT_SOURCE) return;
        scheduleReconcile();
      });
    }
    scheduleReconcile();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})(window);
